import { getOfficeJobProCalander } from "./calander.service";
import { linkOfficeValidate, mergeOfficeValidate } from "./childOffice.service";
import {
  contractDelete,
  contractUpload,
  fileUpload,
  getAdminCommonInfoData,
  getCityDetails,
  getCityList,
  getCommonInfoData,
  getLogNotes,
} from "./common.Info.service";
import {
  addApContactOffice,
  addContactOffice,
  editEmail,
  findContacts,
  getContactTitle,
  getFullContactPermission,
  getOfficeContactView,
  removeContact,
  switchAPContacts,
  switchPrimaryContacts,
  updateContactActivity,
  updateContactOffice,
} from "./contact.service";
import {
  getDashBoardData,
  getJobRedirection,
  getOfficeJobCancellationList,
  getProfessionalJobCancellationList,
} from "./dashboard.service";
import {
  editOfficeApproveReject,
  getOfficeData,
  getOfficeUsers,
  getViewOffice,
} from "./dental.office.service";
import {
  editProfessionalApproveReject,
  getProfessionalUserAllData,
  getProfessionalUsers,
  getReleaseContract,
  updateAdpId,
  updateDob,
  updateMobile,
  updateSalutation,
} from "./dental.professional.service";
import {
  addAddendum,
  cancelManualInvoice,
  childInvoiceAdjust,
  createCreditMemo,
  createManualInvoice,
  createOnAccount,
  deductCreditMemo,
  editInvoiceAfterSend,
  getCreditMemoInfo,
  getCreditMemoList,
  getCreditMemoLogs,
  getInvoiceDetails,
  getInvoiceHistory,
  getInvoiceJobDetails,
  getInvoiceList,
  getInvoiceTimeSheetDetails,
  getJobTimesheets,
  getMasterInvoiceList,
  getOfficeListWithAmount,
  getOnAccountList,
  getOnAccountLogs,
  getPaymentList,
  getProfessionalTimesheetJob,
  getStatement,
  getTimesheetPayments,
  markAsPaid,
  markAsPaidLatePayment,
  markPayment,
  resendInvoice,
  sentInvoice,
  signAddendum,
  updateAmount,
  updateManualInvoice,
  updateOnAccount,
  voidInvoice,
} from "./invoice.sevice";
import {
  adminJobCategory,
  adminViewSkillCategory,
  deleteJobCategory,
  getJobCategory,
  updateJobCategory,
} from "./job.category.service";
import {
  addJobNotes,
  assignApplicant,
  assignRecruiter,
  createExpense,
  editJobNotes,
  fulfillJob,
  getBillDetails,
  getBillRate,
  getCity,
  getJobData,
  getJobLogs,
  getJobNotes,
  getMyAssignmentsList,
  getProfessionalForJob,
  getProfessionalForJobFind,
  getProspectForJobFind,
  getRecruitersForJob,
  getRecruitersJobList,
  getTimesheets,
  unassignApplicant,
  unAssignRecruiter,
} from "./job.service";
import {
  cancelAdminJob,
  createJobByAdmin,
  getAllOfficeList,
  getPostedJobs,
  patchPostedJobsPublishReject,
  updateJobByAdmin,
} from "./jobs.service";
import {
  addOfficeNotes,
  addProfessionalNotes,
  editOfficeNotes,
  editProfessionalNotes,
  getContactFind,
  getDns,
  getDnsLogs,
  getNotes,
  getOfficeNotes,
  getProfessionalNotes,
  getViewNote,
  postponeMarkDoneNotes,
  revertDns,
} from "./notes.service";
import {
  acceptBulkHireRequest,
  changeBulkHireRequestDp,
  createChildOffice,
  createOffice,
  deleteOfficeAccount,
  downloadReport,
  editOfficeContactFields,
  editOfficeMobile,
  editSecondaryEmail,
  enableOrDisableOfficeAccount,
  getBulkHireDashboard,
  getBulkHireHistory,
  getBulkHireProfessionals,
  getBulkHirePrograms,
  getBulkHireRequest,
  getBulkHireRequests,
  getBulkHireSetting,
  getChildOffice,
  getJobHistory,
  getOfficeAccountActivity,
  getOfficeInvoices,
  getOfficeInvoicingSetup,
  getOfficePreview,
  patchBulkHireSetting,
  patchInvoiceCopyReference,
  patchOfficeInvoicingSetup,
  releaseBulkHireAddendum,
  updateOffice,
} from "./office.service";
import {
  createPayRate,
  createTransparencyPayRate,
  getDirectHireFees,
  getOfficePayRangeData,
  getPayRangeData,
  getPayScale,
  getPayScaleOffices,
  getPayScales,
  getTransparencyPayScale,
  patchDirectHireFees,
  patchPayRangeData,
  patchPayScale,
  patchTransparencyFullServiceFees,
  patchTransparencyHourlyEscalations,
  patchTransparencyPayrollBurdenPercentage,
  patchTransparencyPlacementSupportFees,
  switchPayScale,
} from "./pay.range.service";
import {
  deleteProfessionalAccount,
  editProfessionalEmail,
  enableOrDisableProfessionalAccount,
  getJobHistoryProfessional,
  getProfessionalAccountActivity,
  getProfessionalAvailability,
  getProfessionalHiringPreferences,
  getProfessionalPreview,
  saveProfessionalAvailability,
  saveProfessionalHiringPreferences,
  verifyIdentification,
} from "./professional.service";
import {
  approveRejectVersion,
  checkLicense,
  createProfessional,
  getCityDetailsWithState,
  getProfileInfo,
  sendResetPassword,
  submitProfile,
  updateProfessional,
  validateAPAccount,
  validateEmail,
  validateEmailAndMobile,
  validatePrimaryAccount,
} from "./profile.service";
import {
  addNote,
  createProspect,
  deleteProspect,
  doNotDisturb,
  downloadProspectImportFile,
  downloadProspectImportTemplate,
  editProspect,
  getAllProfessionalList,
  getProspectDetails,
  getProspectImportErrors,
  getProspectImportLogs,
  getProspectLogs,
  getProspectNotes,
  getProspects,
  importProspectExcel,
  initiateProspectImport,
  linkProspect,
  markAsHotLead,
  patchProspectOffice,
  updateNote,
} from "./prospect.service";
import { withCache, withRemoveCache } from "./query.service";
import {
  createReferralCategory,
  getReferralCategory,
  getReferralSubCategory,
  mapReferralCategory,
  updateReferralCategory,
} from "./referral.service";
import {
  getManualInvoiceRevenueReport,
  getRevenueReport,
  getRevenueReportById,
} from "./report";
import {
  getContactSense,
  getProfessionalSense,
  getProspectRecruiterLogs,
  getProspectSense,
  updateProspectRecruiterStatus,
  updateRecruiterStatus,
} from "./sense.service";
import {
  getAutoPublishSetting,
  updateAutoPublishSetting,
} from "./settings.service";
import {
  addJobSkill,
  deleteJobSkill,
  getJobskill,
  updateJobSkill,
} from "./skill.service";
import {
  addSoftwareCategory,
  deleteSoftwareCategory,
  editSoftwareCategory,
  getSoftwareCategory,
} from "./Software.management.service";
import {
  addSpecialitySkill,
  deleteSpecialitySkill,
  editSpecialitySkill,
  getSpecialitySkill,
} from "./Speciality.skill.service";
import {
  approveRejectTimeSheet,
  getLateSubmitTimeSheet,
  getProfessionalTimesheetList,
  getTimesheetDetails,
  getTimesheetList,
  updateTimesheet,
} from "./timesheet.service";
import {
  getTimesheetDispute,
  getTimesheetSolveDispute,
} from "./timesheetDispute.service";
import {
  addAdminUser,
  adminLogin,
  adminProfile,
  changePassword,
  contractOfficeUpload,
  contractProfessionalUpload,
  editAdminUser,
  getAdminUser,
  getAdminUserById,
  getAdminUsers,
  getContactAdditionalInfo,
  getDocuments,
  getNotification,
  getRoleModules,
  getTimeZones,
  markAsInvalid,
  previewContract,
  prospectMarkAsInvalid,
  removeAdminUser,
  resetEmail,
  resetPassword,
  saveContactAdditionalInformation,
  saveOfficeAdditionalInformation,
  updateContractOffice,
  updateContractProfessional,
  updateNotification,
  updatePaymentMethod,
  validToken,
} from "./user.service";
const API_SERVICES = {
  CATEGORY_MANAGEMENT: {
    JOB_CATEGORY: {
      ADMIN_JOB_CATEGORY: adminJobCategory,
      ADMIN_VIEW_SKILL_CATEGORY: adminViewSkillCategory,
      DELETE_JOB_CATEGORY: deleteJobCategory,
      EDIT_JOB_CATEGORY: updateJobCategory,
      GET_JOB_CATEGORY: getJobCategory,
    },

    JOB_SKILL: {
      ADD_JOB_SKILL: addJobSkill,
      DELETE_JOB_SKILL: deleteJobSkill,
      GET_JOB_SKILL: getJobskill,
      UPDATE_JOB_SKILL: updateJobSkill,
    },

    MANAGE_SOFTWARE: {
      ADD_MANAGE_SOFTWARE: addSoftwareCategory,
      DELETE_MANAGE_SOFTWARE: deleteSoftwareCategory,
      EDIT_MANAGE_SOFTWARE: editSoftwareCategory,
      GET_MANAGE_SOFTWARE: getSoftwareCategory,
    },

    SPECIALITY_SKILL: {
      ADD_SPECIALITY_SKILL: addSpecialitySkill,
      DELETE_SPECIALITY_SKILL: deleteSpecialitySkill,
      EDIT_SPECIALITY_SKILL: editSpecialitySkill,
      GET_SPECIALITY_SKILL: getSpecialitySkill,
    },
  },
  CHILD_OFFICE: {
    LINK_OFFICE_VALIDATE: withRemoveCache(linkOfficeValidate, [
      "offices-list",
      "office-data",
      "view-office",
      "child-office",
      "notification",
    ]),
    MERGE_OFFICE_VALIDATE: withRemoveCache(mergeOfficeValidate, [
      "offices-list",
      "office-data",
      "view-office",
      "child-office",
      "notification",
    ]),
  },
  COMMON: {
    GET_CITY: getCity,
    GET_NOTIFICATION: withCache(getNotification, "notification"),
    UPDATE_NOTIFICATION: withRemoveCache(updateNotification, ["notification"]),
    GET_TIMEZONE: withCache(getTimeZones, "timezone"),
    GET_LOG_NOTES: withCache(getLogNotes, "log-notes"),
    MARK_AS_INVALID: withRemoveCache(markAsInvalid, [
      "offices-list",
      "notification",
      "office-data",
      "view-office",
      "notification",
    ]),
    PROSPECT_MARK_AS_INVALID: withRemoveCache(prospectMarkAsInvalid, [
      "prospect-list",
      "notification",
    ]),
  },

  CONTACT_VIEW: {
    ADD_CONTACT_OFFICE: withRemoveCache(addContactOffice, [
      "office-contact-view",
      "notification",
    ]),
    EDIT_EMAIL: withRemoveCache(editEmail, [
      "office-contact-view",
      "notification",
    ]),
    GET_CONTACT_VIEW: withCache(getOfficeContactView, "office-contact-view"),
    GET_FULL_CONTACT: withCache(
      getFullContactPermission,
      "full-permission-contact"
    ),
    GET_TITLE: withCache(getContactTitle, "contact-title"),
    REMOVE_CONTACT: withRemoveCache(removeContact, [
      "office-contact-view",
      "notification",
    ]),
    SWITCH_PRIMARY_CONTACT: withRemoveCache(switchPrimaryContacts, [
      "office-contact-view",
      "notification",
    ]),
    UPDATE_CONTACT_OFFICE: withRemoveCache(updateContactOffice, [
      "office-contact-view",
      "notification",
    ]),
    SWITCH_AP_CONTACT: withRemoveCache(switchAPContacts, [
      "office-contact-view",
      "notification",
    ]),
    UPDATE_CONTACT_ACTIVITY_STATUS: withRemoveCache(updateContactActivity, [
      "office-contact-view",
      "notification",
    ]),
    GET_CONTACT_FIND: findContacts,
    ADD_AP_CONTACT: withRemoveCache(addApContactOffice, [
      "view-office",
      "office-contact-view",
    ]),
  },

  CREATE_JOB: {
    GET_ALL_OFFICE_LIST: withCache(getAllOfficeList, "all-office-list"),
    POST_JOB_BY_ADMIN: withRemoveCache(createJobByAdmin, [
      "all-office-list",
      "job-history",
      "notification",
      "dashboard-data",
      "notification",
      "job-history-professional",
    ]),
    UPDATE_JOB_BY_ADMIN: withRemoveCache(updateJobByAdmin, [
      "all-office-list",
      "job-history",
      "notification",
      "dashboard-data",
      "job-history-professional",
    ]),
  },

  COMMON_INFO: {
    GET_ADMIN_COMMON_INFO: withCache(
      getAdminCommonInfoData,
      "admin-common-info"
    ),
    GET_CITY: withCache(getCityList, "city-list"),
    GET_CITY_DETAILS: withCache(getCityDetails, "city-details"),
    GET_COMMON_DATA_INFO: withCache(getCommonInfoData, "common-info-data"),
  },
  DASHBOARD: {
    GET_DASHBOARD_DATA: withCache(getDashBoardData, "dashboard-data"),
    GET_JOB_REDIRECTION: getJobRedirection,
    GET_OFFICE_JOB_CANCELLATION_LIST: withCache(
      getOfficeJobCancellationList,
      "office-job-cancellation-list"
    ),
    GET_PROFESSIONAL_JOB_CANCELLATION_LIST: withCache(
      getProfessionalJobCancellationList,
      "professional-job-cancellation-list"
    ),
  },
  DENTAL_OFFICE: {
    GET_OFFICE_DATA: withCache(getOfficeData, "office-data"),
    GET_OFFICE_USERS: withCache(getOfficeUsers, "offices-list"),
    GET_PAY_SCALE: withCache(getPayScales, "pay-scales"),
    GET_VIEW_OFFICE: withCache(getViewOffice, "view-office"),
    OFFICE_REJECT_APPROVE: withRemoveCache(editOfficeApproveReject, [
      "offices-list",
      "notification",
      "view-office",
      "office-data",
      "notification",
    ]),
    GET_JOB_HISTORY: withCache(getJobHistory, "job-history"),
    SWITCH_PAY_SCALE: withRemoveCache(switchPayScale, ["view-office"]),
  },

  DENTAL_PROFESSIONAL: {
    EDIT_PROFESSIONAL_APPROVE_REJECT: withRemoveCache(
      editProfessionalApproveReject,
      ["professional-list", "professional-data", "notification"]
    ),
    GET_CONTRACT: getReleaseContract,
    GET_PROFESSIONAL_USERS: withCache(
      getProfessionalUsers,
      "professional-list"
    ),
    GET_PROFESSIONAL_USER_ALL_DATA: withCache(
      getProfessionalUserAllData,
      "professional-data"
    ),
    GET_JOB_HISTORY_PROFESSIONAL: withCache(
      getJobHistoryProfessional,
      "job-history-professional"
    ),
    GET_AVAILABILITY: withCache(
      getProfessionalAvailability,
      "professional-availability"
    ),
    GET_HIRING_PREFERENCES: withCache(
      getProfessionalHiringPreferences,
      "professional-hiring-preferences"
    ),
    SAVE_AVAILABILITY: withRemoveCache(saveProfessionalAvailability, [
      "professional-availability",
    ]),
    SAVE_HIRING_PREFERENCES: withRemoveCache(
      saveProfessionalHiringPreferences,
      ["professional-hiring-preferences"]
    ),
    VERIFICATION_IDENTIFICATION: withRemoveCache(verifyIdentification, [
      "professional-data",
    ]),
  },
  EXPENSE: {
    CREATE_EXPENSE: createExpense,
  },
  INVOICE: {
    GET_ALL_INVOICE: withCache(getInvoiceList, "invoice-list"),
    GET_INVOICE_DETAILS: withCache(getInvoiceDetails, "invoice-details"),
    GET_INVOICE_JOB_DETAILS: withCache(
      getInvoiceJobDetails,
      "invoice-job-details"
    ),
    GET_INVOICE_TIME_SHEET_DETAILS: withCache(
      getInvoiceTimeSheetDetails,
      "invoice-time-sheet-details"
    ),
    GET_MASTER_INVOICE_LIST: withCache(
      getMasterInvoiceList,
      "master-invoice-list"
    ),
    GET_ON_ACCOUNT_LIST: withCache(getOnAccountList, "on-account-list"),
    CREATE_ON_ACCOUNT: withRemoveCache(createOnAccount, [
      "on-account-list",
      "notification",
    ]),
    DEDUCT_CREDIT_MEMO: deductCreditMemo,
    UPDATE_ON_ACCOUNT: withRemoveCache(updateOnAccount, [
      "on-account-list",
      "notification",
    ]),
    GET_CREDIT_MEMO_LIST: getCreditMemoList,
    CREATE_CREDIT_MEMO: createCreditMemo,
    GET_TIMESHEET_PAYMENTS: getTimesheetPayments,
    MARK_AS_LATE_PAID: withRemoveCache(markAsPaidLatePayment, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    MARK_AS_PATD: withRemoveCache(markAsPaid, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    CREATE_MANUAL_INVOICE: withRemoveCache(createManualInvoice, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    UPDATE_MANUAL_INVOICE: withRemoveCache(updateManualInvoice, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    CANCEL_MANUAL_INVOICE: withRemoveCache(cancelManualInvoice, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    GET_ON_aCCOUNT_LOGS: getOnAccountLogs,
    GET_CREDIT_MEMO_LOGS: getCreditMemoLogs,
    GET_PAYMENTS: getPaymentList,
    UPDATE_AMOUNT: updateAmount,
    MARK_PAYMENT: markPayment,
    GET_OFFICE_LIST_WITH_AMOUNT: getOfficeListWithAmount,
    SENT_INVOICE: withRemoveCache(sentInvoice, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    STATEMENT: getStatement,
    GET_CREDIT_MEMO_INFO: getCreditMemoInfo,
    ADD_ADDENDUM: addAddendum,
    SIGN_ADDENDUM: signAddendum,
    GET_PROFESSIONAL_TIMESHEET_JOB: getProfessionalTimesheetJob,
    GET_JOB_TIMESHEETS: getJobTimesheets,
    VOID_INVOICE: withRemoveCache(voidInvoice, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    RESEND_INVOICE: withRemoveCache(resendInvoice, [
      "master-invoice-list",
      "invoice-details",
      "invoice-time-sheet-details",
      "invoice-details",
      "notification",
    ]),
    GET_INVOICE_HISTORY: getInvoiceHistory,
    EDIT_INVOICE_AFTER_SEND: editInvoiceAfterSend,
    CHILD_INVOICE_ADJUST: childInvoiceAdjust,
  },
  JOB_CALANDER: {
    GET_OFFICE_JOB_PRO_CALANDER: getOfficeJobProCalander,
  },

  JOB: {
    ASSIGN_APPLICANT: assignApplicant,
    CANCEL_JOB: withRemoveCache(cancelAdminJob, [
      "dashboard-data",
      "notification",
      "job-history-professional",
      "job-history",
    ]),
    FIND_GET_JOB_DATA_PROFESSIONAL: getProfessionalForJobFind,
    FULLFIL_JOB: fulfillJob,
    GET_BILL_DETAILS: getBillDetails,
    GET_BILL_RATE: getBillRate,
    GET_JOB_DATA_PROFESSIONAL: getProfessionalForJob,
    GET_JOB_DATA: getJobData,
    GET_JOB_LOGS: getJobLogs,
    GET_JOB_TIMESHEETS: getTimesheets,
    UNASSIGN_APPLICANT: unassignApplicant,
    FIND_PROSPECTS: getProspectForJobFind,
    ASSIGN_RECRUITER: assignRecruiter,
    GET_RECRUITERS_FOR_JOB: getRecruitersForJob,
    GET_RECRUITERS_JOB_LIST: getRecruitersJobList,
    GET_MY_ASSIGNMENTS_LIST: getMyAssignmentsList,
    GET_NOTES: getJobNotes,
    ADD_NOTE: addJobNotes,
    EDIT_NOTE: editJobNotes,
    UN_ASSIGN_RECRUITER: unAssignRecruiter,
  },

  JOBS: {
    GET_POSTED_JOBS: getPostedJobs,
    PATCH_POSTED_JOBS: patchPostedJobsPublishReject,
  },
  NOTES: {
    GET_NOTES: withCache(getNotes, "dns-notes"),
    GET_DNS: withCache(getDns, "dns"),
    VIEW_NOTE: getViewNote,
    POSTPONE_MARK_NOTE: withRemoveCache(postponeMarkDoneNotes, ["dns-notes"]),
    DNS_REVERT: revertDns,
    GET_DNS_LOGS: withCache(getDnsLogs, "dns-notes-logs"),
    GET_CONTACT_FIND: getContactFind,
  },
  OFFICE: {
    CHILD_OFFICE: withRemoveCache(createChildOffice, [
      "offices-list",
      "child-office",
      "notification",
      "dashboard-data",
    ]),
    CREATE_OFFICE: withRemoveCache(createOffice, [
      "offices-list",
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
    CONTRACT_PREVIEW: getOfficePreview,
    DELETE_ACCOUNT: withRemoveCache(deleteOfficeAccount, [
      "offices-list",
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
    ENABLE_DISABLE_ACCOUNT: withRemoveCache(enableOrDisableOfficeAccount, [
      "offices-list",
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
    GET_ACCOUNT_ACTIVITY_HISTORY: getOfficeAccountActivity,
    GET_CHILD_OFFICE: withCache(getChildOffice, "child-office"),
    UPDATE_OFFICE: withRemoveCache(updateOffice, [
      "offices-list",
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
    GET_OFFICE_INVOICES: getOfficeInvoices,
    GET_BULK_HIRE_DASHBOARD: getBulkHireDashboard,
    GET_BULK_HIRE_HISTORY: getBulkHireHistory,
    GET_BULK_HIRE_PROFESSIONALS: getBulkHireProfessionals,
    GET_BULK_HIRE_PROGRAMS: getBulkHirePrograms,
    GET_BULK_HIRE_REQUEST: getBulkHireRequest,
    ACCEPT_BULK_HIRE_REQUEST: acceptBulkHireRequest,
    CHANGE_BULK_HIRE_REQUEST_DP: changeBulkHireRequestDp,
    GET_BULK_HIRE_REQUESTS: getBulkHireRequests,
    GET_BULK_HIRE_SETTING: getBulkHireSetting,
    GET_INVOICING_SETUP: getOfficeInvoicingSetup,
    PATCH_BULK_HIRE_SETTING: patchBulkHireSetting,
    PATCH_INVOICING_SETUP: patchOfficeInvoicingSetup,
    RELEASE_BULK_HIRE_ADDENDUM: withRemoveCache(releaseBulkHireAddendum, [
      "view-office",
    ]),
    PATCH_INVOICE_COPY_REFERENCE: patchInvoiceCopyReference,
    EDIT_SECONDARY_EMAIL: withRemoveCache(editSecondaryEmail, [
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
    EDIT_CONTACT_FIELDS: withRemoveCache(editOfficeContactFields, [
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
    EDIT_OFFICE_MOBILE: withRemoveCache(editOfficeMobile, [
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
  },
  OFFICE_NOTES: {
    ADD_OFFICE_NOTES: addOfficeNotes,
    EDIT_OFFICE_NOTES: editOfficeNotes,
    GET_OFFICE_NOTES: getOfficeNotes,
  },

  PAY_RANGE: {
    CREATE_PAY_RANGE: createPayRate,
    CREATE_TRANSPARENCY_PAY_SCALE: withRemoveCache(createTransparencyPayRate, [
      "pay-scale",
      "pay-scales",
      "pay-range-data",
      "transparency-pay-scale",
    ]),
    GET_PAY_RANGE_DATA: withCache(getPayRangeData, "pay-range-data"),
    GET_OFFICE_PAY_RANGE_DATA: withCache(
      getOfficePayRangeData,
      "office-pay-range-data"
    ),
    PATCH_PAY_RANGE_DATA: withRemoveCache(patchPayRangeData, [
      "pay-scale",
      "pay-scales",
      "pay-range-data",
      "office-pay-range-data",
    ]),
    GET_PAY_SCALES: withCache(getPayScales, "pay-scales"),
    GET_PAY_SCALE: withCache(getPayScale, "pay-scale"),
    PATCH_PAY_SCALE: withRemoveCache(patchPayScale, [
      "pay-scale",
      "pay-scales",
      "transparency-pay-scale",
    ]),
    GET_TRANSPARENCY_PAY_SCALE: withCache(
      getTransparencyPayScale,
      "transparency-pay-scale"
    ),
    GET_PAY_SCALE_OFFICES: withCache(getPayScaleOffices, "pay-scale-offices"),
    GET_DIRECT_HIRE_FEES: withCache(getDirectHireFees, "direct-hire-fees"),
    PATCH_DIRECT_HIRE_FEES: withRemoveCache(patchDirectHireFees, [
      "direct-hire-fees",
    ]),
    PATCH_TRANSPARENCY_HOURLY_ESCALATIONS: withRemoveCache(
      patchTransparencyHourlyEscalations,
      ["transparency-pay-scale"]
    ),
    PATCH_TRANSPARENCY_FULL_SERVICE_FEES: withRemoveCache(
      patchTransparencyFullServiceFees,
      ["transparency-pay-scale"]
    ),
    PATCH_TRANSPARENCY_PLACEMENT_SUPPORT_FEES: withRemoveCache(
      patchTransparencyPlacementSupportFees,
      ["transparency-pay-scale"]
    ),
    PATCH_TRANSPARENCY_PAYROLL_BURDEN_PERCENTAGE: withRemoveCache(
      patchTransparencyPayrollBurdenPercentage,
      ["transparency-pay-scale", "pay-scale"]
    ),
  },
  PROFESSIONAL: {
    EDIT_EMAIL: withRemoveCache(editProfessionalEmail, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
    DELETE_ACCOUNT: withRemoveCache(deleteProfessionalAccount, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
    ENABLE_DISABLE_ACCOUNT: withRemoveCache(
      enableOrDisableProfessionalAccount,
      ["professional-list", "professional-data", "notification"]
    ),
    GET_ACCOUNT_ACTIVITY_HISTORY: withCache(
      getProfessionalAccountActivity,
      "professional-account-activity"
    ),
    CONTRACT_PREVIEW: getProfessionalPreview,
    UPDATE_DOB: withRemoveCache(updateDob, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
    UPDATE_MOBILE: withRemoveCache(updateMobile, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
    UPDATE_SALUTATION: withRemoveCache(updateSalutation, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
    UPDATE_ADP: withRemoveCache(updateAdpId, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
  },

  PROFESSIONAL_NOTES: {
    ADD_PROFESSIONAL_NOTES: withRemoveCache(addProfessionalNotes, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
    EDIT_PROFESSIONAL_NOTES: withRemoveCache(editProfessionalNotes, [
      "professional-list",
      "professional-data",
      "notification",
    ]),
    GET_PROFESSIONAL_NOTES: getProfessionalNotes,
  },
  PROFILE: {
    APPROVE_REJECT_VERSION: withRemoveCache(approveRejectVersion, [
      "professional-list",
      "professional-view",
      "professional-data",
      "notification",
    ]),
    CONTRACT_DELETE: contractDelete,
    CONTRACT_UPLOAD: withRemoveCache(contractUpload, [
      "professional-list",
      "professional-view",
      "professional-data",
      "offices-list",
      "office-data",
      "view-office",
      "notification",
    ]),
    CREATE_PROFESSIONAL: withRemoveCache(createProfessional, [
      "professional-list",
      "professional-view",
      "professional-data",
      "notification",
      "dashboard-data",
    ]),
    FILE_UPLOAD: fileUpload,
    PRIMARY_ACCOUNT_VALIDATE: validatePrimaryAccount,
    SEND_RESET_PASSWORD: sendResetPassword,
    UPDATE_PROFESSIONAL: withRemoveCache(updateProfessional, [
      "professional-list",
      "professional-view",
      "professional-data",
      "notification",
      "dashboard-data",
    ]),
    VALIDATE_EMAIL: validateEmail,
    VALIDATE_EMAIL_AND_MOBILE: validateEmailAndMobile,
    GET_CITY_DETAILS_WITH_STATE: getCityDetailsWithState,
    CHECK_LICENSE: checkLicense,
    AP_ACCOUNT_VALIDATE: validateAPAccount,
    SUBMIT_PROFILE: withRemoveCache(submitProfile, [
      "professional-list",
      "professional-view",
      "professional-data",
      "offices-list",
      "office-data",
      "view-office",
      "notification",
      "dashboard-data",
    ]),
  },
  PROFILE_COMMON_DATA: withCache(getProfileInfo, "profile-info"),
  PROSPECT: {
    ADD_PROSPECT: createProspect,
    DELETE_PROSPECT: deleteProspect,
    EDIT_PROSPECT: editProspect,
    GET_PROSPECT_DETAILS: getProspectDetails,
    GET_PROSPECT_LIST: getProspects,
    DO_NOT_DISTURB: doNotDisturb,
    GET_NOTES: getProspectNotes,
    ADD_NOTE: addNote,
    UPDATE_NOTE: updateNote,
    LINK_PROSPECT: linkProspect,
    GET_ALL_PROFESSIONAL_LIST: getAllProfessionalList,
    GET_PROSPECT_LOGS: getProspectLogs,
    MARK_AS_HOT_LEAD: markAsHotLead,
    PATCH_PROSPECT_OFFICE: patchProspectOffice,
    GET_CONTACT_FIND: findContacts,
    GET_PROSPECT_RECRUITER_STATUS_LOG: getProspectRecruiterLogs,
    DOWNLOAD_IMPORT_TEMPLATE: downloadProspectImportTemplate,
    IMPORT_EXCEL: importProspectExcel,
    GET_IMPORT_LOG: getProspectImportLogs,
    GET_IMPORT_ERRORS: getProspectImportErrors,
    INITIATE_IMPORT: initiateProspectImport,
    DOWNLOAD_IMPORT_FILE: downloadProspectImportFile,
  },
  SENSE: {
    CONTACT_SENSE: getContactSense,
    PROFESSIONAL_SENSE: getProfessionalSense,
    PROSPECT_SENSE: getProspectSense,
    UPDATE_RECRUITER_STATUS: withRemoveCache(updateRecruiterStatus, [
      "offices-list",
      "office-data",
      "view-office",
      "notification",
    ]),
    UPDATE_PROSPECT_RECRUITER_STATUS: updateProspectRecruiterStatus,
  },
  REFERRAL_MANAGEMENT: {
    CREATE_REFERRAL_CATEGORIES: withRemoveCache(createReferralCategory, [
      "admin-common-info",
      "notification",
    ]),
    GET_REFERRAL_CATEGORIES: withRemoveCache(getReferralCategory, [
      "admin-common-info",
      "notification",
    ]),
    GET_REFERRAL_SUB_CATEGORIES: withRemoveCache(getReferralSubCategory, [
      "admin-common-info",
      "notification",
    ]),
    MAP_REFERRAL_CATEGORIES: withRemoveCache(mapReferralCategory, [
      "admin-common-info",
      "notification",
    ]),
    UPDATE_REFERRAL_CATEGORIES: withRemoveCache(updateReferralCategory, [
      "admin-common-info",
      "notification",
    ]),
  },
  REPORT: {
    DOWNLOAD_REPORT: downloadReport,
  },
  REVENUE_REPORT: {
    GET_REPORT: getRevenueReport,
    GET_REPORT_BY_ID: getRevenueReportById,
    GET_MANUAL_INVOICE_REPORT: getManualInvoiceRevenueReport,
  },
  SETTINGS: {
    GET_AUTO_PUBLISH_SETTING: getAutoPublishSetting,
    UPDATE_AUTO_PUBLISH_SETTING: updateAutoPublishSetting,
  },
  TIMESHEETS: {
    APPROVE_REJECT_TIMESHEET: approveRejectTimeSheet,
    GET_LATE_SUBMIT_TIME_SHEET: getLateSubmitTimeSheet,
    GET_TIMESHEET_DETAILS: getTimesheetDetails,
    GET_TIMESHEET_LIST: getTimesheetList,
    GET_PROFESSIONAL_TIMESHEET_LIST: getProfessionalTimesheetList,
    UPDATE_PROFESSIONAL_TIMESHEET: updateTimesheet,
  },

  TIMESHEET_DISPUTE: {
    GET_TIMESHEET_DISPUTE: getTimesheetDispute,
    TIMESHEET_DISPUTE_SOLVE: getTimesheetSolveDispute,
  },

  USER: {
    ADD_ADMIN_USER: addAdminUser,
    ADMIN_CHANGE_PASSWORD: changePassword,
    ADMIN_LOGIN: adminLogin,
    ADMIN_PROFILE: adminProfile,
    EDIT_ADMIN_USER: editAdminUser,
    GET_ADMIN_USER: getAdminUser,
    GET_ADMIN_USER_BY_ID: getAdminUserById,
    GET_ADDITIONAL_CONTACT_INFORMATION: getContactAdditionalInfo,
    PROFILE_COMMON_DATA: getProfileInfo,
    GET_ADMIN_USERS: getAdminUsers,
    GET_DOCUMENT: getDocuments,
    PREVIEW_CONTRACT: previewContract,
    RELEASE_OFFICE_CONTRACT: withRemoveCache(updateContractOffice, [
      "office-data",
      "office-view",
      "notification",
    ]),
    RELEASE_PROFESSIONAL_CONTRACT: withRemoveCache(updateContractProfessional, [
      "professional-data",
      "professional-view",
      "professional-list",
      "notification",
    ]),
    REMOVE_ADMIN_USER: removeAdminUser,
    RESET_EMAIL: resetEmail,
    RESET_PASSWORD: resetPassword,
    SAVE_ADDITIONAL_INFORMATION: withRemoveCache(
      saveOfficeAdditionalInformation,
      [
        "office-data",
        "professional-data",
        "professional-view",
        "office-view",
        "professional-list",
        "notification",
      ]
    ),
    SAVE_CONTACT_ADDITIONAL_INFORMATION: withRemoveCache(
      saveContactAdditionalInformation,
      [
        "office-data",
        "professional-data",
        "professional-view",
        "office-view",
        "professional-list",
        "notification",
      ]
    ),
    VALID_TOKEN: validToken,
    GET_ROLE_MODULES: withCache(getRoleModules, "admin-role-modules"),
    UPDATE_PAYMENT_METHOD: withRemoveCache(updatePaymentMethod, [
      "office-data",
      "professional-data",
      "professional-view",
      "office-view",
      "professional-list",
      "notification",
    ]),
    UPLOAD_OFFICE_CONTRACT: withRemoveCache(contractOfficeUpload, [
      "office-data",
      "office-view",
      "notification",
    ]),
    UPLOAD_PROFESSIONAL_CONTRACT: withRemoveCache(contractProfessionalUpload, [
      "professional-data",
      "professional-view",
      "professional-list",
      "notification",
    ]),
  },
};

export default API_SERVICES;
